<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：云仓-云仓明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="formInline.product_name" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="云仓变动类型">
          <el-select v-model="formInline.type" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item,index) in Scene" :key="index" :label="item.name" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user" label="微信头像" width="80">
            <template slot-scope="scope" v-if="scope.row.user">
              <img v-img-url="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户" width="400">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>等级：{{scope.row.user.grade.name}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="product.product_name" label="产品名称"></el-table-column>
          <el-table-column prop="type" label="云仓变动类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type==10" style="color: #409EFF">入仓</span>
              <span v-if="scope.row.type==20" style="color: #67C23A">自提</span>
              <span v-if="scope.row.type==30" style="color: #F56C6C">出仓</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_number" label="变动数量"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>


  </div>
</template>

<script>
  import WarehouseApi from '@/api/warehouse.js'
  export default {

    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user_id: '',
          product_name: '',
          type: '',
          create_time: ''
        },
        /*场景*/
        Scene: [
          {
            name: '入仓',
            type: '10'
          },
          {
            name: '自提',
            type: '20'
          },
          {
            name: '出仓',
            type: '30'
          },
        ],
        /*时间*/
        value1: '',
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        console.log(Params);
        WarehouseApi.getList(Params, true)
        .then(res => {
         self.tableData = res.data.detail.data;
         self.totalDataNumber = res.data.detail.total;
         self.loading = false;
        })
        .catch(error => {
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/warehouse/log/index.vue